export const NONE = 'none';
export const SORTABLE = 'sortable';
export const NESTABLE = 'nestable';
